import { useFields as useProfessionalContactFields } from '../fields/professionalContactFields';

/**
 * `useFields` is a custom hook that handles the management of fields in a groomer form. It maintains the state of various fields and fetches necessary enums from the API.
 *
 * @returns {Object} - An object that contains a fields array with the structure and state of each form field.
 */
export const useFields = () => useProfessionalContactFields('groomer');
